import type { ReactNode } from 'react';

/** Full-height single message, used for loading and terminal states. */
export const Centered = ({ children }: { children: ReactNode }) => (
  <div className="flex min-h-full items-center justify-center px-6 text-center">
    <p className="max-w-sm text-sm text-soft">{children}</p>
  </div>
);
